export const FIELD_TO_SERVICE_MAP: Record<string, string> = {
    componentCodeAnchorKey: 'componentCodes',
    primaryAddressAnchorKey: 'addresses',
    componentAnchorKey: 'components',
    userFunctionAnchorKey: 'userFunctions',
    useCaseAnchorKey: 'useCases',
    functionCategoryAnchorKey: 'functionCategories',
    segmentAnchorKey: 'segments',
    signalAnchorKey: 'signals',
    sourceAeAnchorKey: 'allocationElements',
    targetAeAnchorKey: 'allocationElements',
    fvBoxPortDataRelationAnchorKey: 'fvBoxPortDataRelations',
    valueDescriptionAnchorKey: 'valueDescriptions',
};
